require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-neudorf.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-neudorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-neudorf!./.cache/json/betreuungseinrichtungen-neusiedl-neudorf.json
// module id = 956
// module chunks = 231608221292675